var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 60,
    viewBox: "0 0 100 60",
    id: "svg312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g314"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 40,
    fill: "#e0e0e0",
    stroke: "#666666",
    strokeWidth: 2,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 70,
    height: 30,
    fill: "none",
    stroke: "#999999",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 20,
    x2: 85,
    y2: 20,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 25,
    x2: 85,
    y2: 25,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 30,
    x2: 85,
    y2: 30,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 35,
    x2: 85,
    y2: 35,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 40,
    x2: 85,
    y2: 40,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: 15,
    x2: 25,
    y2: 45,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 15,
    x2: 35,
    y2: 45,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 15,
    x2: 45,
    y2: 45,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 15,
    x2: 55,
    y2: 45,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 15,
    x2: 65,
    y2: 45,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 15,
    x2: 75,
    y2: 45,
    stroke: "#999999",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 2,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 20,
    r: 2,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 2,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 40,
    r: 2,
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 25,
    width: 8,
    height: 3,
    fill: "#666666",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 25,
    width: 8,
    height: 3,
    fill: "#666666",
    rx: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirout);
export default __webpack_public_path__ + "static/media/airout.55b6df75a303270152f0dc57ef878315.svg";
export { ForwardRef as ReactComponent };